import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import axios from 'axios'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueLazyload from 'vue-lazyload'
import VueFriendlyIframe from 'vue-friendly-iframe';
import VueMoment from 'vue-moment';
import VueClipboard from 'vue-clipboard2'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/index.css'

Vue.prototype.$Axios = axios;
Vue.config.productionTip = false;

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueLazyload)
Vue.use(VueFriendlyIframe);
Vue.use(VueMoment)
Vue.use(VueClipboard)

// Vue.use(VueLazyload, {
//     preLoad: 1.3,
//     error: 'dist/error.png',
//     loading: 'dist/loading.gif',
//     attempt: 1
// })

Vue.mixin({
    data(){
        return{
            site : 'Artube',
            host: 'https://webtoon.artube.video:5443/attwebtoon/api/v1/',               //live
            // host: 'https://attwallet.numbers21.com:5443/attwebtoon/api/v1',             //test
            // host: 'http://172.30.1.107:8443/manager/api/v1',                            // th local
            // host: 'http://numbers21.fortiddns.com:9090/manager/api/v1',                 //kiru local
            // host: 'https://attwallet.numbers21.com:5443/artubewebtoon/api/v1',          //dev

            // league_host: 'https://attwallet.numbers21.com:5443/attwebtoon/api/v2',             //test
            league_host: 'https://webtoon.artube.video:5443/attwebtoon/api/v2',             //live
            // league_host: 'http://172.30.1.107:8000/manager/api/v2',             //th local

            siteConfig: null,
            mixin_hashtagList: [
                {hsName:'#서스펜스', adult:false, hsIdx:96}
            ,   {hsName:'#보다보니정주행', adult:false, hsIdx:97}
            ,   {hsName:'#소년만화', adult:false, hsIdx:42}
            ,   {hsName:'#선남선녀', adult:false, hsIdx:98}
            ,   {hsName:'#예측불가', adult:false, hsIdx:99}
            ,   {hsName:'#액션쾌감', adult:false, hsIdx:100}
                
            
            ,   {hsName:'#거유', adult:true, hsIdx:10}
            ,   {hsName:'#오피스걸', adult:true, hsIdx:101}
            ,   {hsName:'#섹시녀', adult:true, hsIdx:41}
            ,   {hsName:'#고수위', adult:true, hsIdx:14}
            ,   {hsName:'#그녀의유혹', adult:true, hsIdx:102}
            ,   {hsName:'#명품스토리', adult:true, hsIdx:103}
            ]
        }
    },
    beforeDestroy(){
        this.isCheckedLogin = false;
    },
    methods: {
        mobileCheck(){
            var u = navigator.userAgent || '';
            var isMobile = /(Windows CE|IEmobile|LG|MOT|SonyEricsson|SAMSUNG|BlackBerry|iphone|ios|android|Opera Mini|mini|mobile|Opera Mobi|mobi|Nokia|Symbian|iPod|iPad|Windows\s+Phone|MQQBrowser|wp7|wp8|UCBrowser7|UCWEB|360\s+Aphone\s+Browser)/i.test(u);
            if(isMobile){
                return true;
            } else {
                return false;
            }
        },
        async mixinSiteConfigCheck(){
            // if(this.$store.state.siteConfig === null){
            if(this.siteConfig === null){
                var param = 
                {
                    k: "99990000",
                    t: new Date().getTime(),
                }
                await this.$Axios.post(`${this.host}/config/site`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                    if(res.data.returnCode === 0){
                        // this.$store.state.siteConfig = res.data.data;
                        this.siteConfig = res.data.data;
                        // console.log(this.siteConfig);
                    }
                })
            }
        },
        async mixinLoginCheck() {
            if(this.$store.state.sign !== '' && this.$store.state.ticket !== ''){
                var param = 
                {
                    email: this.$store.state.email,
                    sign: this.$store.state.sign,
                    ticket: this.$store.state.ticket,
                    viewAdult: this.$store.state.isCheckedAdult ? 1 : 0
                }
                await this.$Axios.post(`${this.host}/member/ticket/check`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(async res => {
                    // console.log(res);
                    if (res.data.returnCode === 0) {
                        await this.$store.commit("setProfile", this.host);
                    }
                    else {
                        await this.$store.commit("logout");
                    }
                }).catch(error => {
                    error;
                    console.log(error);
                    // this.$store.commit("logout");
                    // this.$router.push('/');
                })
            }
            else{
                await this.$store.commit("logout");
            }
        },
        //로컬스토리지에 객체저장
        fn_setLocalStorage(name,obj){
            localStorage.setItem(name, obj);
        },
        //로컬스토리지에 특정 객체 삭제
        fn_removeLocalStorage(name){
            localStorage.removeItem(name);
        },
        //로컬스토리지에서 특정 객체 가져오기
        fn_getItemLocalStorage(name){
            return localStorage.getItem(name);
        },
    }
})

Vue.filter('comma', function (val) {
    var filter_str = '';
    var isMinus = false;
    if(val < 0){
        isMinus = true;
        val = val.toString().replace('-', '');
    }

    if(val >= 0 && val !== null && val !== undefined){
        var split_num = val.toString().split('.');
        filter_str = String(split_num[0]).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        if(split_num[1]){
            filter_str = filter_str + '.' + split_num[1];
        }
    }

    if(filter_str === '' || filter_str === null || filter_str === undefined){
        filter_str = '0';
    }

    if(isMinus){
      filter_str = '-' + filter_str;
    }

    return filter_str;
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
